network.$inject = ["$http"];

function network($http) {
  //var baseUrl = "http://18.237.217.101:3333/";
  //var baseUrl = "http://localhost:9000/";
  var baseUrl = "https://live.bookbyslot.com/";
  // var token= "9b4c9a55e87d29e754d12200c772fd90019863af";
  // var userId= "57e4c2f9305a190192a5e1bd";

  //< !--signup -->

  network.signup = function(name, email, password, countryCode, mobileNumber) {
    return $http({
      method: "POST",
      url: baseUrl + "api/LoginSignup/signup",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        // "userId": userId
        name: name,
        email: email,
        password: password,
        countryCode: countryCode,
        mobileNumber: mobileNumber
      }
    });
  };

  //< !--login -->

  network.login = function(email, password, loginType) {
    return $http({
      method: "POST",
      url: baseUrl + "api/LoginSignup/login",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        // "userId": userId
        email: email,
        password: password,
        loginType: "LOGIN"
      }
    });
  };

  //< !--facebook login-- >

  network.facebookLogin = function(
    facebookUserId,
    facebookAccessToken,
    loginType,
    name,
    birthday,
    gender,
    email
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/LoginSignup/login",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        facebookUserId: facebookUserId,
        facebookAccessToken: facebookAccessToken,
        loginType: "FB",
        name: name,
        birthday: birthday,
        gender: gender,
        email: email
      }
    });
  };

  //< !--google login-- >

  network.googleLogin = function(
    googleUserId,
    googleAccessToken,
    loginType,
    name,
    birthday,
    gender,
    email
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/LoginSignup/login",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        googleUserId: googleUserId,
        googleAccessToken: googleAccessToken,
        loginType: "GOOGLE",
        name: name,
        birthday: birthday,
        gender: gender,
        email: email
      }
    });
  };

  network.paytmLogin = function(
    data,
    openId
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/LoginSignup/login",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        info: data,
        loginType: "PAYTM",
        openId: openId
      }
    });
  };

  network.ppLogin = function(
    data
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/LoginSignup/login",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        tokenInfo: data,
        loginType: "PhonePe"
      }
    });
  };

  
  //< !--logout -->

  network.logout = function(userId, authToken) {
    return $http({
      method: "POST",
      url: baseUrl + "api/LoginSignup/logout",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        userId: userId,
        authToken: authToken
      }
    });
  };

  // password reset

  network.passwordReset = function(email) {
    return $http({
      method: "GET",
      url: baseUrl + "api/LoginSignup/forgotPassword/" + email
    });
  };

  //< !--Search for hotels - Slot-- >

  network.getHotelsSlot = function(
    hotelSlotCheckInTime,
    hotelSlotCheckInTimeHours,
    hotelSlotCheckInTimeMinutes,
    latitude,
    longitude,
    city,
    country,
    searchText,
    filters,
    slotHours,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    workFromHotel
  ) {
    var d = {
      // "userId": userId
      hotelSlotCheckInTime: hotelSlotCheckInTime,
      hotelSlotCheckInTimeMinutes: hotelSlotCheckInTimeMinutes,
      hotelSlotCheckInTimeHours: hotelSlotCheckInTimeHours,
      latitude: parseFloat(latitude),
      longitude: parseFloat(longitude),
      searchText: searchText,
      filters: filters,
      slotHours: parseFloat(slotHours),
      numberOfRooms: parseFloat(numberOfRooms),
      numberOfAdults: parseFloat(numberOfAdults),
      numberOfChildren: parseFloat(numberOfChildren),
      city: city,
      country: country,
      workFromHotel: workFromHotel
    };
    // console.log(d);
    return $http({
      method: "POST",
      url: baseUrl + "api/search/searchForHotelsSlot",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: d
    });
  };

  //< !--Search for hotels - Nights-- >

  network.getHotelsNights = function(
    hotelSlotCheckInTime,
    hotelCheckOutTime,
    latitude,
    longitude,
    city,
    country,
    searchText,
    filters,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    type
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/search/searchForHotelsNight",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        // "userId": userId
        hotelCheckInTime: hotelSlotCheckInTime,
        hotelCheckOutTime: hotelCheckOutTime,
        latitude: latitude,
        longitude: longitude,
        searchText: searchText,
        filters: filters,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        city: city,
        country: country,
        type: type
      }
    });
  };

  //< !--HotelInfo for slots-- >

  network.getHotelInfoSlot = function(
    hotelId,
    hotelSlotCheckInTime,
    hotelSlotCheckInTimeHours,
    hotelSlotCheckInTimeMinutes,
    slotHours,
    lat,
    lng,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    workFromHotel
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/search/searchForOneHotelAndRoomsSlot",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        // "userId": userId
        hotelSlotCheckInTime: hotelSlotCheckInTime,
        hotelSlotCheckInTimeMinutes: hotelSlotCheckInTimeMinutes,
        hotelSlotCheckInTimeHours: hotelSlotCheckInTimeHours,
        slotHours: slotHours,
        hotelId: hotelId,
        latitude: lat,
        longitude: lng,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        workFromHotel: workFromHotel
      }
    });
  };

  //< !--HotelInfo for nights-- >

  network.getHotelInfoNights = function(
    hotelId,
    hotelCheckInTime,
    hotelCheckOutTime,
    lat,
    lng,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/search/searchForOneHotelAndRoomsNight",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        // "userId": userId
        hotelCheckInTime: hotelCheckInTime,
        hotelCheckOutTime: hotelCheckOutTime,
        hotelId: hotelId,
        latitude: lat,
        longitude: lng,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode
      }
    });
  };

  //< !--Room info slot-- >

  network.roomInfoSlot = function(
    hotelSlotCheckInTime,
    hotelSlotCheckInTimeMinutes,
    hotelSlotCheckInTimeHours,
    lat,
    lng,
    hotelId,
    roomId,
    slotHours,
    slotName,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/search/searchForOneHotelAndOneRoomSlot",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        // "userId": userId
        hotelSlotCheckInTime: hotelSlotCheckInTime,
        hotelSlotCheckInTimeMinutes: hotelSlotCheckInTimeMinutes,
        hotelSlotCheckInTimeHours: hotelSlotCheckInTimeHours,
        latitude: lat,
        longitude: lng,
        hotelId: hotelId,
        roomId: roomId,
        slotHours: slotHours,
        slotName: slotName,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode
      }
    });
  };

  //< !--Room info nights-- >

  network.roomInfoNight = function(
    hotelCheckInTime,
    hotelCheckOutTime,
    lat,
    lng,
    hotelId,
    roomId,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    RatePlanId
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/search/searchForOneHotelAndOneRoomNight",
      headers: {
        "Content-Type": "application/json"
        // 'authToken': token
      },
      data: {
        // "userId": userId
        hotelCheckInTime: hotelCheckInTime,
        hotelCheckOutTime: hotelCheckOutTime,
        latitude: lat,
        longitude: lng,
        hotelId: hotelId,
        roomId: roomId,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        RatePlanId: RatePlanId
      }
    });
  };

  //< !--Book a room-- >

  network.bookARoom = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    checkInTime,
    checkOutTime,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    final_price_at_booking,
    final_price_at_checkout,
    partner_data,
    couponCode,
    hotelName,
    roomName,
    hotelDetails,
    hotelImage,
    payAmount
  ) {
    var dataLocal = {
      userId: userId,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
      hotelId: hotelId,
      roomId: roomId,
      checkInTime: checkInTime,
      checkOutTime: checkOutTime,
      numberOfRooms: numberOfRooms,
      numberOfAdults: numberOfAdults,
      numberOfChildren: numberOfChildren,
      sourcedFrom: sourcedFrom,
      currencyCode: currencyCode,
      final_price_at_booking: final_price_at_booking,
      final_price_at_checkout: final_price_at_checkout,
      partner_data: partner_data,
      couponCode: couponCode,
      hotelName: hotelName,
      roomName: roomName,
      HotelImageURL: hotelImage,
      payAmount: payAmount
    };
    if (hotelDetails) {
      dataLocal.hotel_details = hotelDetails;
    }
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomNight",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: dataLocal
    });
  };
  //< !--Book a room At Hotel-- >

  network.bookARoomAtHotel = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    checkInTime,
    checkOutTime,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    final_price_at_booking,
    final_price_at_checkout,
    partner_data,
    couponCode,
    hotelName,
    roomName,
    hotelDetails,
    hotelImage
  ) {
    var dataLocal = {
      userId: userId,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
      hotelId: hotelId,
      roomId: roomId,
      checkInTime: checkInTime,
      checkOutTime: checkOutTime,
      numberOfRooms: numberOfRooms,
      numberOfAdults: numberOfAdults,
      numberOfChildren: numberOfChildren,
      sourcedFrom: sourcedFrom,
      currencyCode: currencyCode,
      final_price_at_booking: final_price_at_booking,
      final_price_at_checkout: final_price_at_checkout,
      partner_data: partner_data,
      couponCode: couponCode,
      hotelName: hotelName,
      roomName: roomName,
      HotelImageURL: hotelImage
    };
    if (hotelDetails) {
      dataLocal.hotel_details = hotelDetails;
    }
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomNightAtHotel",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: dataLocal
    });
  };
  network.bookARoomCorporate = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    checkInTime,
    checkOutTime,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    final_price_at_booking,
    final_price_at_checkout,
    partner_data,
    couponCode,
    hotelName,
    roomName,
    hotelDetails,
    hotelImage
  ) {
    var dataLocal = {
      userId: userId,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
      hotelId: hotelId,
      roomId: roomId,
      checkInTime: checkInTime,
      checkOutTime: checkOutTime,
      numberOfRooms: numberOfRooms,
      numberOfAdults: numberOfAdults,
      numberOfChildren: numberOfChildren,
      sourcedFrom: sourcedFrom,
      currencyCode: currencyCode,
      final_price_at_booking: final_price_at_booking,
      final_price_at_checkout: final_price_at_checkout,
      partner_data: partner_data,
      couponCode: couponCode,
      hotelName: hotelName,
      roomName: roomName,
      HotelImageURL: hotelImage
    };
    if (hotelDetails) {
      dataLocal.hotel_details = hotelDetails;
    }
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomNightCorporate",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: dataLocal
    });
  };
  //< !--Book a room Guest-- >

  network.bookARoomGuest = function(
    hotelId,
    userName,
    userEmail,
    userMobile,
    roomId,
    tempcheckin,
    tempcheckout,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    final_price_at_booking,
    final_price_at_checkout,
    partner_data,
    couponCode,
    hotelName,
    roomName,
    hotelDetails,
    hotelImage
  ) {
    var dataLocal = {
      hotelId: hotelId,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
      roomId: roomId,
      checkInTime: tempcheckin,
      checkOutTime: tempcheckout,
      numberOfRooms: numberOfRooms,
      numberOfAdults: numberOfAdults,
      numberOfChildren: numberOfChildren,
      sourcedFrom: sourcedFrom,
      currencyCode: currencyCode,
      final_price_at_booking: final_price_at_booking,
      final_price_at_checkout: final_price_at_checkout,
      partner_data: partner_data,
      couponCode: couponCode,
      hotelName: hotelName,
      roomName: roomName,
      HotelImageURL: hotelImage
    };
    if (hotelDetails) {
      dataLocal.hotel_details = hotelDetails;
    }
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomNight",
      headers: {
        "Content-Type": "application/json"
      },
      data: dataLocal
    });
  };
  //< !--Book a room Guest At Hotel-- >

  network.bookARoomGuestAtHotel = function(
    hotelId,
    userName,
    userEmail,
    userMobile,
    roomId,
    tempcheckin,
    tempcheckout,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    final_price_at_booking,
    final_price_at_checkout,
    partner_data,
    couponCode,
    hotelName,
    roomName,
    hotelDetails,
    hotelImage
  ) {
    var dataLocal = {
      hotelId: hotelId,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
      roomId: roomId,
      checkInTime: tempcheckin,
      checkOutTime: tempcheckout,
      numberOfRooms: numberOfRooms,
      numberOfAdults: numberOfAdults,
      numberOfChildren: numberOfChildren,
      sourcedFrom: sourcedFrom,
      currencyCode: currencyCode,
      final_price_at_booking: final_price_at_booking,
      final_price_at_checkout: final_price_at_checkout,
      partner_data: partner_data,
      couponCode: couponCode,
      hotelName: hotelName,
      roomName: roomName,
      HotelImageURL: hotelImage
    };
    if (hotelDetails) {
      dataLocal.hotel_details = hotelDetails;
    }
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomNightAtHotel",
      headers: {
        "Content-Type": "application/json"
      },
      data: dataLocal
    });
  };
  //< !--Book a slot as a user-- >

  network.bookASlot = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlot",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,
        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };

  network.bookASlotEF = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlotEF",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,
        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };

  network.bookASlotGuestEF = function(
    hotelId,
    userName,
    userEmail,
    userMobile,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlotEF",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,

        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };

  network.bookARoomEF = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    checkInTime,
    checkOutTime,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    final_price_at_booking,
    final_price_at_checkout,
    partner_data,
    couponCode,
    hotelName,
    roomName,
    hotelDetails,
    hotelImage,
    payAmount
  ) {
    var dataLocal = {
      userId: userId,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
      hotelId: hotelId,
      roomId: roomId,
      checkInTime: checkInTime,
      checkOutTime: checkOutTime,
      numberOfRooms: numberOfRooms,
      numberOfAdults: numberOfAdults,
      numberOfChildren: numberOfChildren,
      sourcedFrom: sourcedFrom,
      currencyCode: currencyCode,
      final_price_at_booking: final_price_at_booking,
      final_price_at_checkout: final_price_at_checkout,
      partner_data: partner_data,
      couponCode: couponCode,
      hotelName: hotelName,
      roomName: roomName,
      HotelImageURL: hotelImage,
      payAmount: payAmount
    };
    if (hotelDetails) {
      dataLocal.hotel_details = hotelDetails;
    }
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomNightEF",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: dataLocal
    });
  };

  network.bookARoomGuestEF = function(
    hotelId,
    userName,
    userEmail,
    userMobile,
    roomId,
    tempcheckin,
    tempcheckout,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    final_price_at_booking,
    final_price_at_checkout,
    partner_data,
    couponCode,
    hotelName,
    roomName,
    hotelDetails,
    hotelImage
  ) {
    var dataLocal = {
      hotelId: hotelId,
      userName: userName,
      userEmail: userEmail,
      userMobile: userMobile,
      roomId: roomId,
      checkInTime: tempcheckin,
      checkOutTime: tempcheckout,
      numberOfRooms: numberOfRooms,
      numberOfAdults: numberOfAdults,
      numberOfChildren: numberOfChildren,
      sourcedFrom: sourcedFrom,
      currencyCode: currencyCode,
      final_price_at_booking: final_price_at_booking,
      final_price_at_checkout: final_price_at_checkout,
      partner_data: partner_data,
      couponCode: couponCode,
      hotelName: hotelName,
      roomName: roomName,
      HotelImageURL: hotelImage
    };
    if (hotelDetails) {
      dataLocal.hotel_details = hotelDetails;
    }
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomNightEF",
      headers: {
        "Content-Type": "application/json"
      },
      data: dataLocal
    });
  };

  network.bookASlotPayTM = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlot",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,
        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };
  //< !--Book a slot as a user At Hotel-- >

  network.bookASlotAtHotel = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlotAtHotel",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,
        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };
  //< !--Book a slot as a Guest-- >
  network.bookASlotCorporate = function(
    authToken,
    userId,
    userName,
    userEmail,
    userMobile,
    hotelId,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlotCorporate",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,
        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };
  network.bookASlotGuest = function(
    hotelId,
    userName,
    userEmail,
    userMobile,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlot",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,

        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };
  //< !--Book a slot as a Guest At Hotel-- >

  network.bookASlotGuestAtHotel = function(
    hotelId,
    userName,
    userEmail,
    userMobile,
    roomId,
    slotName,
    checkInTime,
    mins,
    hrs,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    sourcedFrom,
    currencyCode,
    couponCode,
    hotelName,
    roomName,
    hotelImage
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/bookRoomSlotAtHotel",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        userName: userName,
        userEmail: userEmail,
        userMobile: userMobile,

        hotelId: hotelId,
        roomId: roomId,
        slotName: slotName,
        checkInTime: checkInTime,
        hotelSlotCheckInTimeMinutes: mins,
        hotelSlotCheckInTimeHours: hrs,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        sourcedFrom: sourcedFrom,
        currencyCode: currencyCode,
        couponCode: couponCode,
        hotelName: hotelName,
        roomName: roomName,
        HotelImageURL: hotelImage
      }
    });
  };
  //< !--Coupon code-- >
  network.getCoupons = function(userId) {
    return $http({
      method: "POST",
      url: baseUrl + "api/user/getCoupons",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        userId: userId
      }
    });
  };
  network.checkCouponCode = function(
    authToken,
    userId,
    hotelId,
    roomId,
    couponCode,
    totalPrice,
    slotName,
    type,
    mainPrice
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/user/checkCouponCode",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        hotelId: hotelId,
        roomId: roomId,
        couponCode: couponCode,
        totalPrice: totalPrice,
        SlotInfo: slotName,
        type: type,
        mainPrice: mainPrice
      }
    });
  };
  network.checkCouponCodeForMaximojo = function(
    authToken,
    userId,
    hotelCheckInTime,
    hotelCheckOutTime,
    hotelId,
    roomId,
    numberOfRooms,
    numberOfAdults,
    numberOfChildren,
    currencyCode,
    RatePlanId,
    couponCode,
    totalPrice
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/user/checkCouponCodeForMaximojo",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        hotelCheckInTime: hotelCheckInTime,
        hotelCheckOutTime: hotelCheckOutTime,
        hotelId: hotelId,
        roomId: roomId,
        numberOfRooms: numberOfRooms,
        numberOfAdults: numberOfAdults,
        numberOfChildren: numberOfChildren,
        currencyCode: currencyCode,
        RatePlanId: RatePlanId,
        couponCode: couponCode,
        totalPrice: totalPrice
      }
    });
  };

  //< !--Get Hotel Reviews-- >

  network.getHotelReviews = function(hotelId) {
    return $http({
      method: "GET",
      url: baseUrl + "api/reviews/getHotelReviews/" + hotelId,
      headers: {
        "Content-Type": "application/json"
      }
    });
  };

  //< !--Get Profile Info-- >

  network.getProfileInfo = function(userId, authToken) {
    return $http({
      method: "POST",
      url: baseUrl + "api/user/profileInfo",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId
      }
    });
  };

  //< !--Update Profile Info-- >

  network.updateUserInfo = function(
    userId,
    authToken,
    name,
    mobileNumber,
    mobileCode,
    email,
    birthday,
    place
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/user/updateUserInfo",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        mobileNumber: mobileNumber,
        countryCode: mobileCode,
        address_line1: place,
        // "address_line2": "Line 2",
        // "address_locality": "Locality",
        // "address_city": "City",
        // "address_state": "State",
        // "address_country": "Country",
        // "address_zipCode": "Zip Code",
        // "address_latitude": "Latitude",
        // "address_longitude": "Longitude",
        birthday: birthday
        // "gender": "FEMALE",
      }
    });
  };

  //< !--Edit Profile Picture-- >

  network.editProfilePicture = function(formdata, headers) {
    var headersLocal = {};
    if (headers) {
      headersLocal = headers;
    }
    headersLocal["Content-Type"] = undefined;
    return $http({
      method: "POST",
      url: baseUrl + "api/user/editProfilePicture",
      headers: headersLocal,
      transformRequest: angular.identity,
      data: formdata
    });
  };

  //< !--Hotel Booking History-- >

  network.getHotelBookingHistory = function(userId, authToken) {
    return $http({
      method: "POST",
      url: baseUrl + "api/user/getHotelBookingHistory",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId
      }
    });
  };

  //< !--Review a hotel-- >

  network.reviewAHotel = function(userId, authToken, hotelId, rating, review) {
    // console.log(userId, authToken);
    // console.log("n/w", hotelId, rating, review);

    return $http({
      method: "POST",
      url: baseUrl + "api/reviews/reviewAHotel",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        userId: userId,
        hotelId: hotelId,
        rating: parseInt(rating),
        review: review
      }
    });
  };

  //< !--Get CCAvenue Details-- >

  network.getpayTmDetails = function(bookingId) {
    return $http({
      method: "GET",
      url: baseUrl + "api/book/paytmMakePayment/" + bookingId
    });
  };
  network.getCCAvenueDetails = function(bookingId) {
    return $http({
      method: "GET",
      url: baseUrl + "api/book/ccavenueMakePayment/" + bookingId
    });
  };

  // contact us email
  network.sendEmailFromContactUs = function(data) {
    return $http({
      method: "POST",
      url: baseUrl + "api/queryForms/contactUs",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    });
  };

  // Partner with us email
  network.sendEmailFromHotel = function(data) {
    return $http({
      method: "POST",
      url: baseUrl + "api/queryForms/PartnerWithUs/Hotel",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    });
  };
  network.sendEmailFromCorporate = function(data) {
    return $http({
      method: "POST",
      url: baseUrl + "api/queryForms/PartnerWithUs/Corporate",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    });
  };
  network.sendEmailFromAgent = function(data) {
    return $http({
      method: "POST",
      url: baseUrl + "api/queryForms/PartnerWithUs/TravelAgents",
      headers: {
        "Content-Type": "application/json"
      },
      data: data
    });
  };

  network.getCheckInTimeAndSlots = function(date, timeZoneOffset) {
    return $http({
      method: "GET",
      url:
        baseUrl +
        "api/search/getSearchScreenData" +
        "?date=" +
        date +
        "&timeZoneOffset=" +
        timeZoneOffset,
      headers: {
        "Content-Type": "application/json"
      }
    });
  };

  network.paytmToken = function(authToken) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/paytmToken",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        authToken: authToken
      }
    });
  };

  network.paytmToken1 = function(clientId, authToken, clientSecret) {
    var host = "https://accounts-uat.paytm.com";
    var obj = {
      grant_type: "authorization_code",
      code: authToken,
      client_id: clientId,
      scope: "basic"
    };
    var str = [];
    for(var p in obj)
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    var url =  str.join("&");
    return $http({
      method: "POST",
      url: host + "/oauth2/v2/token?"+url,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": "Basic "+btoa(clientId+":"+clientSecret)
      }
    });
  };

  network.paytmUserDetails = function(authToken) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/paytmUserDetails",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        authToken: authToken
      }
    });
  };

  network.paytmInitiateTransaction = function(
    authToken,
    CUSTOMER_ID,
    ORDERID,
    TXNAMOUNT,
    CURRENCY
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/paytmMini",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        CUSTOMER_ID: CUSTOMER_ID,
        ORDERID: ORDERID,
        TXNAMOUNT: TXNAMOUNT,
        CURRENCY: CURRENCY
      }
    });
  };

  network.getPPTransactionDetails = function(
    ORDER_ID,
    authToken
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/ppTransactionDetails",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        ORDERID: ORDER_ID
      }
    });
  };

  network.ppInitiateTransaction = function(
    authToken,
    CUSTOMER_ID,
    ORDERID,
    TXNAMOUNT,
    CURRENCY,
    hotelId, checkInTime, checkOutTime, numberOfRooms, numberOfAdults, 
    numberOfChildren, hotelName, hotelAddress, slotMinutes
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/ppPayment",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        CUSTOMER_ID: CUSTOMER_ID,
        ORDERID: ORDERID,
        TXNAMOUNT: TXNAMOUNT,
        CURRENCY: CURRENCY,
        hotelId: hotelId, checkInTime: checkInTime, checkOutTime: checkOutTime, 
        numberOfRooms: numberOfRooms, numberOfAdults: numberOfAdults, slotMinutes: slotMinutes,
        numberOfChildren: numberOfChildren, hotelName: hotelName, hotelAddress: hotelAddress
      }
    });
  };

  network.ppCheckTransaction = function(
    authToken,
    ORDERID
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/ppTransactionStatusC",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        ORDERID: ORDERID
      }
    });
  };

  network.paytmSaveTransaction = function(
    authToken, 
    BANKNAME,
    BANKTXNID,
    CHECKSUMHASH,
    CURRENCY,
    GATEWAYNAME,
    MID,
    ORDERID,
    PAYMENTMODE,
    RESPCODE,
    RESPMSG,
    STATUS,
    TXNAMOUNT,
    TXNDATE,
    TXNID
  ) {
    var data = $.param({
      BANKNAME: BANKNAME,
      BANKTXNID: BANKTXNID,
      CHECKSUMHASH: CHECKSUMHASH,
      CURRENCY: CURRENCY,
      GATEWAYNAME: GATEWAYNAME,
      MID: MID,
      ORDERID: ORDERID,
      PAYMENTMODE: PAYMENTMODE,
      RESPCODE: RESPCODE,
      RESPMSG: RESPMSG,
      STATUS: STATUS,
      TXNAMOUNT: TXNAMOUNT,
      TXNDATE: TXNDATE,
      TXNID: TXNID
    });
    window.location.href = baseUrl + "api/book/paytmMiniRedirectWebsite?"+data;
  };

  network.getUserOpenIdFromDB = function(
    authToken,
    MODE,
    EMAIL,
    openId
  ) {
    return $http({
      method: "POST",
      url: baseUrl + "api/book/getSetOpenId",
      headers: {
        "Content-Type": "application/json",
        authToken: authToken
      },
      data: {
        MODE: MODE,
        EMAIL: EMAIL,
        OPENID: openId
      }
    });
  };
    //< !--Quiz World Cup-- >

    network.SubmitQuiz = function (
        authToken,
        userId,
        userName,
        userEmail,
        userMobile,
        QuestionOne,
        AnswerOne,
        QuestionTwo,
        AnswerTwo,
        QuestionThree,
        AnswerThree
    ) {
        var dataLocal = {
            userId: userId,
            userName: userName,
            userEmail: userEmail,
            userMobile: userMobile,
            QuestionOne: QuestionOne,
            AnswerOne: AnswerOne,
            QuestionTwo: QuestionTwo,
            AnswerTwo: AnswerTwo,
            QuestionThree: QuestionThree,
            AnswerThree: AnswerThree            
        };       
        return $http({
            method: "POST",
            url: baseUrl + "api/bbsleague/submitQuiz",
            headers: {
                "Content-Type": "application/json",
                authToken: authToken
            }, 
            data: dataLocal
        });
    };

    network.getSettings = function () {
      return $http({
        method: "GET",
        url: baseUrl + "api/setting/get",
        headers: {
          "Content-Type": "application/json",
        },
      });
    }; 

  return network;
}

export default network;
